import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { selectCampaignMetrics } from 'modules/campaignAnalytics/selectors';
import { fetchMetricsForCampaignRequest } from 'modules/campaignAnalytics/actions';
import { useInAppRecall } from './useInAppRecall';
import { useModalContext, useCampaignContext, ModalType } from '../../context';

export const IN_APP_RECALL_MODAL_TEST_ID = 'in-app-recall-campaign-modal';
export const IN_APP_RECALL_BUTTON_TEST_ID = 'in-app-recall-campaign-button';

export const InAppRecallModal = () => {
  const { closeModal } = useModalContext();
  const { isLoading, recallInApp } = useInAppRecall();
  const { campaign } = useCampaignContext();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryData = {
      startTime: new Date(0).toISOString(),
      endTime: new Date().toISOString(),
      selectedMetrics: [{ name: 'UniqueInAppSend' }, { name: 'UniqueInAppOpen' }],
      campaignId: campaign.id,
    };
    dispatch(fetchMetricsForCampaignRequest(queryData));
  }, []);

  const campaignMetrics = useSelector(selectCampaignMetrics);
  const uniqueInAppSends = campaignMetrics['Unique In-app Sends']?.value;
  const uniqueInAppOpens = campaignMetrics['Unique In-app Opens']?.value;
  const hasMetrics = uniqueInAppSends !== undefined && uniqueInAppOpens !== undefined;

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.InAppRecallModal)}
      id="in-app-recall-modal"
      data-test={IN_APP_RECALL_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Recall campaign?</ModalHeader>

      {hasMetrics ? (
        <ModalBody>
          This will remove the <strong>{campaign.name}</strong> in-app message from{' '}
          {uniqueInAppSends} users&apos; devices/queues.
          <hr />({uniqueInAppOpens} {uniqueInAppOpens === 1 ? 'user has' : 'users have'} already
          viewed it.)
        </ModalBody>
      ) : (
        <ModalBody>
          This will remove the <strong>{campaign.name}</strong> in-app message from users&apos;
          devices/queues.
        </ModalBody>
      )}

      <ModalFooter>
        <Button
          data-test={IN_APP_RECALL_BUTTON_TEST_ID}
          onClick={recallInApp}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
        >
          Recall campaign
        </Button>
      </ModalFooter>
    </Modal>
  );
};
